export default __webpack_public_path__ + "assets/media/logo-creator-2x.a32142cc.png";